import axios from "axios";

/** After JSON.parse(page.content): unwrap kv-blocks-v1 or use a legacy top-level rows array. */
export function normalizeKvBlocksRows(parsed) {
   if (parsed?.format === "kv-blocks-v1" && Array.isArray(parsed.rows)) {
      return parsed.rows;
   }
   if (Array.isArray(parsed)) {
      return parsed;
   }
   return [];
}

export const request = axios.create({
   baseURL: "https://kv-engine-v3-prod.onrender.com/v1"
   // baseURL: "https://staging-api.knight.ventures/"
});
